import { UserGradeSummaryRepositoryType, UserGradeSummaryResponseType } from '../types';

export interface IGetUserGradeSummaryUsecase {
  invoke(userId: number): Promise<UserGradeSummaryResponseType>;
}

export class GetUserGradeSummaryUsecaseImpl implements IGetUserGradeSummaryUsecase {
  constructor(private repository: UserGradeSummaryRepositoryType) {}

  invoke(userId: number): Promise<UserGradeSummaryResponseType> {
    return this.repository.getUserGradeSummary(userId);
  }
}
